export default {
  namespaced: true,
  state: {
  	isChoosing: false,
    choosedElement: null,
  },
  mutations: {
    SET_CHOOSED_ELEMENT(state, data) {
      state.choosedElement = data 
    },
    SET_CHOOSING(state, data) {
      state.isChoosing = data 
    },
  },
  actions: {
    UPDATE_CHOOSED_ELEMENT({ commit }, data) {
      commit('SET_CHOOSED_ELEMENT', data) 
    },
    UPDATE_CHOOSING({ commit }, data) {
      commit('SET_CHOOSING', data) 
    },
  },
  getters: {
    choosedElement: state => state.choosedElement,
    isChoosing: state => state.isChoosing,
  }
}